module.exports = __webpack_public_path__ + "static/media/favicon.b6b4b4be.ico";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/favicon.ico
// module id = 214
// module chunks = 0